import { InjectionToken } from '@angular/core';
import type { IssuerEnvironment } from '@env/environment.model';

export type { IssuerEnvironment } from '@env/environment.model';

export const ISSUER_ENV = new InjectionToken<IssuerEnvironment>('ISSUER_ENV');
